module.exports = __webpack_public_path__ + "media/Team/Paul-7d24fd34.jpeg";